import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import cx from 'classnames';
import Form from './Form';
import SuccessMessage from './SuccessMessage';

const rootNode = document.getElementById('press-pass-form-root');
const buttonNode = document.getElementById('press-form-button');
const textNode = document.getElementById('press-form-text');
const { sitekey } = rootNode.dataset;

const PressPass = () => {
  const [step, setStep] = useState('form');
  const [showForm, setShowform] = useState(false);

  const onButtonClick = () => {
    buttonNode.classList.add('hidden');
    textNode.classList.add('hidden');
    setShowform(true);
  };

  buttonNode.addEventListener('click', () => onButtonClick());

  return (
    <div className={cx('d-flex flex-column flex-grow')}>
      {showForm && (
        <div className="press-pass-from-box">
          <div className="flex-no-shrink d-flex flex-wrap flex-column w-100" >
            <h2 className="d-flex justify-content-center text-white align-items-center text-16 text-uppercase m-b-mdl">Get your press pass to Apptopia</h2>
          </div>
          {step === 'form' && showForm && <Form handleStep={setStep} sitekey={sitekey} />}
          {step === 'success' && <SuccessMessage />}
        </div>
      )}
    </div>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<PressPass />);
});
